import { __decorate } from "tslib";
import * as CONST from '../const';
import notError from 'not-error/src/error.browser';
import Reportable from '../decorators/reportable';
import UICommon from './common';
import FormElementRenderer from './form.el';
import UIOverlay from './overlay';
import UIPreviewCloseupRenderer from './closeup.renderer';
class FormElementBagetRenderer extends FormElementRenderer {
    overlay;
    preselectedBagetId;
    BAGET_CONTAINER = 'overlay_container_baget';
    BAGET_PREVIEW_CLOSEUP_CONTAINER_ID = 'baget-preview';
    CONTAINER_TYPE = 'baget';
    option;
    previewRenderer;
    constructor(owner) {
        super(owner);
        this.previewRenderer = new UIPreviewCloseupRenderer(owner, this.owner.getProject(), this.CONTAINER_TYPE, this.BAGET_PREVIEW_CLOSEUP_CONTAINER_ID, false);
    }
    render(option, cont, index) {
        this.option = option;
        if (Array.isArray(option.variants)) {
            const element = this.buildElement(option, index);
            cont.appendChild(element);
            //this.initCarousel();
            this.bindEvents(cont, option);
            this.updateSelectedBagetInput();
        }
    }
    updateFromSummary(option, summary) {
        this.updateSelectedBagetInput();
    }
    sortVariants(variants) {
        variants = variants.sort((item1, item2) => {
            return item2.price > item1.price ? -1 : 1;
        });
    }
    convertBagetURL(url) {
        return `https://muse.ooo/upload/bagets/${url}`;
    }
    buildBagetHTML(option) {
        const baget = this.owner.getActivePropertyValue(option.optionName);
        if (baget) {
            return this.buildSelectedBagetHTML(baget);
        }
        else {
            return this.buildEmptyBagetHTML();
        }
    }
    buildEmptyBagetHTML() {
        return `<div class="baget">...</div>`;
    }
    buildSelectedBagetHTML(baget) {
        const bagetURL = this.convertBagetURL(baget.value.cornerOriginalFile);
        return `
      <div class="selected_baget">
      <img alt="${baget.value.name}"  data-id="${baget.id}"
      decode="async"
      class="current_baget image--xs" loading="eager"
      src="${bagetURL}"/></div>`;
    }
    buildElement(option, index) {
        let list = '';
        const price = UICommon.formatPrice(this.owner.getPropertyPrice(option.optionName));
        const hidden = this.getHiddenClass(option), inDigital = this.checkIfOptionIsDigital(option) ? 'digital' : '', inRolled = this.checkIfOptionIsRolled(option) ? 'rolled' : '', tooltip = this.returnTooltipTrigger();
        const el = document.createElement('div');
        if (Array.isArray(option.variants)) {
            option.variants.forEach((item, index) => {
                const selected = (((option.default === (item._id + '')) || (typeof option.default === 'undefined' && index === 0))) ? 'selected="selected" ' : '';
                list += `<option class="hidden" ${selected} value="${item.id}">${item.title}</option>`;
            });
            [CONST.OPT_CLASS_OPTION_NORMAL, inDigital, inRolled, hidden].forEach(name => name && el.classList.add(name));
            el.id = `option_${option.optionName}`;
            el.innerHTML = `
       <label class="align-content-left"><span>${option.title}</span> ${tooltip}</label>
       <div class="input-select">
        <select data-option-id="${option.id}" name="select_${this.getElementId(option)}" tabindex="${index}">${list}</select>
       </div><span class="price">${price}</span>`;
        }
        return el;
    }
    bindEvents(cont, option) {
        this.bindTooltip(option);
        const selectBaget = cont.querySelector('select');
        if (selectBaget) {
            selectBaget.addEventListener('mousedown', (e) => {
                e.preventDefault();
                e.target.blur();
                this.openBagetSelector(option);
                return false;
            });
        }
        else {
            throw new notError('No select baget element', { option });
        }
        const deselectBaget = cont.querySelector('.baget_empty');
        if (deselectBaget) {
            deselectBaget.addEventListener('click', () => this.deselectBaget(option));
        }
        else {
            //throw new Error('No deselect baget element');
        }
    }
    openBagetSelector(option) {
        console.log('open baget selector');
        this.renderOverlay();
        this.renderOverlayContent(option);
    }
    deselectBaget(option) {
        console.log('deselect baget');
        this.owner.removeProjectProperty(option.optionName);
        this.updateSelectedBagetInput();
    }
    renderOverlay() {
        if (typeof this.overlay === 'undefined') {
            this.overlay = new UIOverlay({
                data: {
                    'calculatorId': this.owner.getUniqueId()
                },
                containerId: `calculator-container-${this.CONTAINER_TYPE}`,
                contentId: this.BAGET_CONTAINER,
                layer: CONST.CLOSEUP_LAYER
            });
        }
        this.overlay.render(100, ['scroll-less', 'wide']);
    }
    renderOverlayContent(option) {
        const cont = document.querySelector('#overlay_container_baget');
        if (!cont) {
            return;
        }
        this.buildInBagetSelectorLine(cont, option);
        this.buildInButtonLine(cont);
        this.previewRenderer.render();
        this.updateBagetCloseupPreview();
    }
    updateBagetCloseupPreview() {
        this.owner.getPreview().renderCloseup(this.CONTAINER_TYPE);
    }
    applySelection() {
        //console.log('baget selected', this.preselectedBagetId);
        if (this.preselectedBagetId) {
            this.owner.changeProjectProperty('baget', this.preselectedBagetId);
            this.updateSelectedBagetInput();
        }
    }
    buildInButtonLine(cont) {
        const buttonLine = document.createElement('DIV');
        buttonLine.classList.add('overlay-button-line');
        cont.appendChild(buttonLine);
        buttonLine.innerHTML = `<button type="submit" class="btn btn--lg btn--primary type--uppercase overlay-baget-add">Выбрать</button>`;
        const selectBtn = cont.querySelector('.overlay-baget-add');
        if (!selectBtn) {
            throw new Error('No baget select button in overlay');
        }
        selectBtn.addEventListener('click', () => {
            this.applySelection();
            this.overlay && this.overlay.close();
        });
    }
    buildInBagetSelectorLine(cont, option) {
        const bagetLine = document.createElement('DIV');
        bagetLine.classList.add('overlay-baget-selector-line');
        cont.appendChild(bagetLine);
        bagetLine.innerHTML = `
      <div id="baget-preview"></div>
      <div class="baget-list"></div>`;
        const listContEl = bagetLine.querySelector('.baget-list');
        if (!listContEl) {
            throw new Error('No baget list in overlay');
        }
        if (option.variants && Array.isArray(option.variants)) {
            option.variants.forEach((bagetVariant) => {
                const bagetVariantEl = this.createBagetListElement(bagetVariant);
                listContEl && listContEl.appendChild(bagetVariantEl);
            });
        }
        this.updateBagetSelectorActiveBaget();
        const currentBaget = this.owner.getActivePropertyValue('baget');
        if (currentBaget) {
            //this.updateBagetInfoCard(currentBaget);
            this.updateBagetCloseupPreview();
        }
    }
    createBagetListElement(bagetVariant) {
        const el = document.createElement('div');
        el.classList.add('baget-variant');
        el.dataset.id = `${bagetVariant.id}`;
        const price = UICommon.formatPrice(this.owner.getBagetPrice(bagetVariant.id));
        let bagetURL = CONST.NO_BAGET_IMAGE_URL;
        if (CONST.NO_BAGET_CODE_NAME !== bagetVariant.value.name) {
            bagetURL = this.convertBagetURL(bagetVariant.value.cornerOriginalFile);
            el.innerHTML = `<img
        alt="${bagetVariant.value.name}"  data-id="${bagetVariant.id}"
        class="" loading="eager"
        src="${bagetURL}"/>
        <div class="baget_price" data-option-id="${bagetVariant.id}">${price}</div>`;
        }
        else {
            el.innerHTML = `<a class="no-baget" href="#"></a><div class="baget_price" data-option-id="${bagetVariant.id}">Нет</div>`;
        }
        el.addEventListener('click', (e) => {
            e.preventDefault();
            this.stripShadowing();
            if (CONST.NO_BAGET_CODE_NAME === bagetVariant.codeName && this.option) {
                this.deselectBaget(this.option);
            }
            else {
                this.preselectBaget(bagetVariant);
            }
            this.applySelection();
        });
        return el;
    }
    preselectBaget(bagetVariant) {
        this.preselectedBagetId = bagetVariant.id;
        this.updateBagetSelectorActiveBaget();
        //this.updateBagetInfoCard(bagetVariant);
        this.updateBagetCloseupPreview();
    }
    updateBagetSelectorActiveBaget() {
        const els = document.querySelectorAll('.baget-list .baget-variant');
        if (els) {
            Array.from(els).forEach((el) => {
                el.classList.remove('preselected');
                if (el.dataset.id === `${this.preselectedBagetId}`) {
                    el.classList.add('preselected');
                }
            });
        }
    }
    updateBagetInfoCard(bagetVariant) {
        const cont = document.querySelector('.overlay-baget-selector-line .baget-info .baget-info-properties');
        if (!cont) {
            throw new Error('No .baget-info-properties element in overlay to show baget properties');
        }
        cont.innerHTML = '';
        if (Array.isArray(bagetVariant.properties)) {
            bagetVariant.properties.forEach((property) => {
                this.addBagetPropertyLine(cont, property);
            });
        }
        const imgCont = document.querySelector('.overlay-baget-selector-line .baget-info .baget-info-img');
        if (!imgCont) {
            throw new Error('No .baget-info-img element in overlay to show baget image');
        }
        const bagetURL = this.convertBagetURL(bagetVariant.value.cornerOriginalFile);
        imgCont.innerHTML = `<img
      alt="${bagetVariant.value.name}"  data-id="${bagetVariant.id}"
      class="" loading="eager"
      src="${bagetURL}"/>`;
    }
    addBagetPropertyLine(cont, property) {
        const lineEl = document.createElement('div');
        lineEl.classList.add('baget-property');
        lineEl.innerHTML = `
      <span class="baget-property-title">${property.title}</span>
      <span class="baget-property-value">${property.value}</span>
    `;
        const triggerEl = lineEl.querySelector('.baget-property-value');
        if (triggerEl) {
            triggerEl.addEventListener('click', () => this.filterBagetsByProperty(property));
        }
        cont.appendChild(lineEl);
    }
    filterBagetsByProperty(property) {
        if (this.option &&
            this.option.variants &&
            Array.isArray(this.option.variants)) {
            const filtered = this.option.variants.filter(variant => this.testVariantAgainstProperty(variant, property)).map(el => el.id);
            this.highlightList(filtered);
        }
    }
    extractId(el) {
        const idStr = el.dataset.id;
        if (idStr) {
            return parseInt(idStr);
        }
        return 0;
    }
    highlightList(ids) {
        const els = document.querySelectorAll('.baget-list .baget-variant');
        if (els) {
            Array.from(els).forEach((el) => {
                const id = this.extractId(el);
                if (id) {
                    if (ids.includes(id)) {
                        el.classList.remove('shadow');
                    }
                    else {
                        el.classList.add('shadow');
                    }
                }
            });
        }
    }
    stripShadowing() {
        const els = document.querySelectorAll('.baget-list .baget-variant');
        if (els) {
            Array.from(els).forEach((el) => {
                el.classList.remove('shadow');
            });
        }
    }
    testVariantAgainstProperty(baget, property) {
        if (baget.properties && Array.isArray(baget.properties)) {
            return baget.properties.some((prop) => {
                return (prop.title === property.title) && (prop.value === property.value);
            });
        }
        return false;
    }
    updatePreselectedBaget() {
        const currentBaget = this.owner.getActivePropertyValue('baget');
        if (currentBaget) {
            this.preselectedBagetId = currentBaget.id;
        }
        else {
            this.preselectedBagetId = undefined;
        }
    }
    updateSelectedBagetInput() {
        const currentBaget = this.owner.getActivePropertyValue('baget');
        if (currentBaget) {
            this.setSelectedBagetInputFilled(currentBaget);
        }
        else {
            this.setSelectedBagetInputEmpty();
        }
    }
    setSelectedBagetInputFilled(currentBaget) {
        if (typeof this.option === 'undefined') {
            return;
        }
        const cont = document.querySelector(`select[name="select_${this.getElementId(this.option)}"] option[value="${currentBaget.id}"]`);
        if (cont) {
            cont.selected = true;
        }
    }
    setSelectedBagetInputEmpty() {
        const cont = document.querySelector('.baget_selection_element');
        if (cont) {
            const emptyTile = cont.querySelector('.baget_empty');
            if (emptyTile) {
                emptyTile.classList.add('active');
            }
            const selectedTile = cont.querySelector('.baget_selected');
            if (selectedTile) {
                selectedTile.classList.remove('active');
                const bagetImg = selectedTile.querySelector('img');
                if (bagetImg && bagetImg.parentNode) {
                    bagetImg.parentNode.innerHTML = '...';
                }
                const bagetTitleEl = selectedTile.querySelector('.baget_tile_title_content');
                if (bagetTitleEl) {
                    bagetTitleEl.innerHTML = 'Выбрать';
                }
                const bagetPriceEl = selectedTile.querySelector('.price');
                if (bagetPriceEl) {
                    bagetPriceEl.classList.add('empty');
                    bagetPriceEl.innerHTML = '';
                }
            }
        }
    }
}
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "render", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "sortVariants", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildBagetHTML", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildEmptyBagetHTML", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildSelectedBagetHTML", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildElement", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "bindEvents", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "openBagetSelector", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "deselectBaget", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "renderOverlay", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "renderOverlayContent", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "applySelection", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildInButtonLine", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "buildInBagetSelectorLine", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "createBagetListElement", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "preselectBaget", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "updateBagetInfoCard", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "addBagetPropertyLine", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "filterBagetsByProperty", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "stripShadowing", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "updatePreselectedBaget", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "updateSelectedBagetInput", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "setSelectedBagetInputFilled", null);
__decorate([
    Reportable
], FormElementBagetRenderer.prototype, "setSelectedBagetInputEmpty", null);
export default FormElementBagetRenderer;
